module.exports = __webpack_public_path__ + "static/media/exukonline-how-to-buy-basket.1103ebfb.png";